import styles from "../../../moveout-checklist.module.css";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { X } from "react-feather";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";

const schema = yup.object().shape({
  kitchenfloorCovering: yup.string(),
  kitchenfloorCoveringOther: yup.string(),
  kitchenWallsCeiling: yup.string(),
  kitchenWallsCeilingOther: yup.string(),
  kitchenWindow: yup.string(),
  kitchenWindowOther: yup.string(),
  kitchenWindowConvering: yup.string(),
  kitchenWindowConveringOther: yup.string(),
  kitchenLightingFans: yup.string(),
  kitchenLightingFansOther: yup.string(),
  kitchenDoorHardware: yup.string(),
  kitchenDoorHardwareOther: yup.string(),
  kitchenHeating: yup.string(),
  kitchenHeatingOther: yup.string(),
  kitchenOutletsSwitches: yup.string(),
  kitchenOutletsSwitchesOther: yup.string(),
  kitchenSmokeAlarm: yup.string(),
  kitchenSmokeAlarmOther: yup.string(),
  kitchenCabinetsHardware: yup.string(),
  kitchenCabinetsHardwareOther: yup.string(),
  kitchenRefrigerator: yup.string(),
  kitchenRefrigeratorOther: yup.string(),
  kitchenStoveOven: yup.string(),
  kitchenStoveOvenOther: yup.string(),
  kitchenStoveVent: yup.string(),
  kitchenStoveVentOther: yup.string(),
  kitchenMicrowave: yup.string(),
  kitchenMicrowaveOther: yup.string(),
  kitchenDishwasher: yup.string(),
  kitchenDishwasherOther: yup.string(),
  kitchenSinkFixtures: yup.string(),
  kitchenSinkFixturesOther: yup.string(),
  kitchenCounter: yup.string(),
  kitchenCounterOther: yup.string(),
  kitchenGarbageDisposal: yup.string(),
  kitchenGarbageDisposalOther: yup.string(),
  kitchenWasherDryer: yup.string(),
  kitchenWasherDryerOther: yup.string(),
  kitchenDryerVent: yup.string(),
  kitchenOther: yup.string(),
  kitchenOtherOther: yup.string(),
});

const KitchenForm = ({
  onSubmitArrivalForm,
  tenantId,
  setLoading,
  moveOutCheckListInfo,
  handleChange4,
}) => {
  const [uploadedImages, setUploadedImages] = useState([]);
  const { getAccessTokenSilently } = useAuth0();

  const {
    control,
    handleSubmit,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const kitchenValues = useWatch({
    control,
  });

  useEffect(() => {
    // setValue("kitchenfloorCovering", "new");
    // setTimeout(() => {
    //   setValue("kitchenWallsCeiling", "new");
    //   setv((p) => !p);
    // }, 2000);

    if (!moveOutCheckListInfo?.kitchen_data) return;

    const data = moveOutCheckListInfo.kitchen_data;

    Object.entries(data).forEach(([key, field]) => {
      if (!field || typeof field !== "object") return;

      const { value, is_other } = field;

      // Safely check that a value exists before setting
      if (is_other === 1 && value) {
        // setValue(key, "other");
        // setValue(`${key}Other`, value);
      } else if (is_other === 0 && value) {
        // setValue(key, value);
      }
      // else: don't call setValue at all
    });

    // Populate image state
    if (Array.isArray(moveOutCheckListInfo.kitchen_images)) {
      // setUploadedImages(moveOutCheckListInfo.kitchen_images);
    }
  }, [moveOutCheckListInfo, setValue]);

  const onSubmit = (data) => {
    const sectionName = "kitchen_data";
    const formattedData = {
      kitchenfloorCovering: {
        value:
          data.kitchenfloorCovering === "other"
            ? data.kitchenfloorCoveringOther
            : data.kitchenfloorCovering,
        is_other: data.kitchenfloorCovering === "other" ? 1 : 0,
      },
      kitchenWallsCeiling: {
        value:
          data.kitchenWallsCeiling === "other"
            ? data.kitchenWallsCeilingOther
            : data.kitchenWallsCeiling,
        is_other: data.kitchenWallsCeiling === "other" ? 1 : 0,
      },
      kitchenWindow: {
        value:
          data.kitchenWindow === "other"
            ? data.kitchenWindowOther
            : data.kitchenWindow,
        is_other: data.kitchenWindow === "other" ? 1 : 0,
      },
      kitchenWindowConvering: {
        value:
          data.kitchenWindowConvering === "other"
            ? data.kitchenWindowConveringOther
            : data.kitchenWindowConvering,
        is_other: data.kitchenWindowConvering === "other" ? 1 : 0,
      },
      kitchenLightingFans: {
        value:
          data.kitchenLightingFans === "other"
            ? data.kitchenLightingFansOther
            : data.kitchenLightingFans,
        is_other: data.kitchenLightingFans === "other" ? 1 : 0,
      },
      kitchenDoorHardware: {
        value:
          data.kitchenDoorHardware === "other"
            ? data.kitchenDoorHardwareOther
            : data.kitchenDoorHardware,
        is_other: data.kitchenDoorHardware === "other" ? 1 : 0,
      },
      kitchenHeating: {
        value:
          data.kitchenHeating === "other"
            ? data.kitchenHeatingOther
            : data.kitchenHeating,
        is_other: data.kitchenHeating === "other" ? 1 : 0,
      },
      kitchenOutletsSwitches: {
        value:
          data.kitchenOutletsSwitches === "other"
            ? data.kitchenOutletsSwitchesOther
            : data.kitchenOutletsSwitches,
        is_other: data.kitchenOutletsSwitches === "other" ? 1 : 0,
      },
      kitchenSmokeAlarm: {
        value:
          data.kitchenSmokeAlarm === "other"
            ? data.kitchenSmokeAlarmOther
            : data.kitchenSmokeAlarm,
        is_other: data.kitchenSmokeAlarm === "other" ? 1 : 0,
      },
      kitchenCabinetsHardware: {
        value:
          data.kitchenCabinetsHardware === "other"
            ? data.kitchenCabinetsHardwareOther
            : data.kitchenCabinetsHardware,
        is_other: data.kitchenCabinetsHardware === "other" ? 1 : 0,
      },
      kitchenRefrigerator: {
        value:
          data.kitchenRefrigerator === "other"
            ? data.kitchenRefrigeratorOther
            : data.kitchenRefrigerator,
        is_other: data.kitchenRefrigerator === "other" ? 1 : 0,
      },
      kitchenStoveOven: {
        value:
          data.kitchenStoveOven === "other"
            ? data.kitchenStoveOvenOther
            : data.kitchenStoveOven,
        is_other: data.kitchenStoveOven === "other" ? 1 : 0,
      },
      kitchenStoveVent: {
        value:
          data.kitchenStoveVent === "other"
            ? data.kitchenStoveVentOther
            : data.kitchenStoveVent,
        is_other: data.kitchenStoveVent === "other" ? 1 : 0,
      },
      kitchenMicrowave: {
        value:
          data.kitchenMicrowave === "other"
            ? data.kitchenMicrowaveOther
            : data.kitchenMicrowave,
        is_other: data.kitchenMicrowave === "other" ? 1 : 0,
      },
      kitchenDishwasher: {
        value:
          data.kitchenDishwasher === "other"
            ? data.kitchenDishwasherOther
            : data.kitchenDishwasher,
        is_other: data.kitchenDishwasher === "other" ? 1 : 0,
      },
      kitchenSinkFixtures: {
        value:
          data.kitchenSinkFixtures === "other"
            ? data.kitchenSinkFixturesOther
            : data.kitchenSinkFixtures,
        is_other: data.kitchenSinkFixtures === "other" ? 1 : 0,
      },
      kitchenCounter: {
        value:
          data.kitchenCounter === "other"
            ? data.kitchenCounterOther
            : data.kitchenCounter,
        is_other: data.kitchenCounter === "other" ? 1 : 0,
      },
      kitchenGarbageDisposal: {
        value:
          data.kitchenGarbageDisposal === "other"
            ? data.kitchenGarbageDisposalOther
            : data.kitchenGarbageDisposal,
        is_other: data.kitchenGarbageDisposal === "other" ? 1 : 0,
      },
      kitchenWasherDryer: {
        value:
          data.kitchenWasherDryer === "other"
            ? data.kitchenWasherDryerOther
            : data.kitchenWasherDryer,
        is_other: data.kitchenWasherDryer === "other" ? 1 : 0,
      },
      kitchenDryerVent: {
        value:
          data.kitchenDryerVent === "other"
            ? data.kitchenDryerVentOther
            : data.kitchenDryerVent,
        is_other: data.kitchenDryerVent === "other" ? 1 : 0,
      },
      kitchenOther: {
        value:
          data.kitchenOther === "other"
            ? data.kitchenOtherOther
            : data.kitchenOther,
        is_other: data.kitchenOther === "other" ? 1 : 0,
      },
    };

    const imageFiles = uploadedImages.map((img) => img.file_path);
    const imageSectionName = "kitchen_images";

    onSubmitArrivalForm(
      formattedData,
      sectionName,
      imageFiles,
      imageSectionName
    );

    // handleChange4("panel2")("event", true);
  };

  const handleImageChange = async (event) => {
    const files = Array.from(event.target.files);
    setLoading(true);

    try {
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      });

      for (const file of files) {
        const formData = new FormData();
        formData.append("image", file);

        const response = await axios.post(
          process.env.REACT_APP_PAYMENT_API_URL +
          `v1/move-out-report-file-upload`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        const { file_path, file_url } = response.data.data;

        setUploadedImages((prev) => [...prev, { file_path, file_url }]);
      }
      toast.success(`Images are uploaded`);
    } catch (error) {
      console.error("Upload error:", error);
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Image upload failed");
      }
    } finally {
      setLoading(false);
    }
  };

  const removeImage = (fileNameToRemove) => {
    setUploadedImages((prev) =>
      prev.filter((img) => img.file_path !== fileNameToRemove)
    );
  };

  return (
    <div className={`${styles.FormSec}`}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>1. Floor and Floor Covering</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenfloorCovering"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenfloorCovering === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenfloorCoveringOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>2. Walls and Ceiling/Caulking</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenWallsCeiling"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenWallsCeiling === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenWallsCeilingOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>3. Window(s)</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenWindow"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenWindow === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenWindowOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>4. Window Covering(s)</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenWindowConvering"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenWindowConvering === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenWindowConveringOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>5. Lighting Fixture(s)/Fans</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenLightingFans"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenLightingFans === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenLightingFansOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>6. Door(s)/Hardware</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenDoorHardware"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenDoorHardware === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenDoorHardwareOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>7. Heating</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenHeating"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenHeating === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenHeatingOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>8. Outlets/Switches</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenOutletsSwitches"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenOutletsSwitches === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenOutletsSwitchesOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>9. Smoke Alarms/CO Alarms</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenSmokeAlarm"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenSmokeAlarm === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenSmokeAlarmOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>10. Cabinets/Hardware</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenCabinetsHardware"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenCabinetsHardware === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenCabinetsHardwareOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>11. Refrigerator</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenRefrigerator"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenRefrigerator === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenRefrigeratorOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>12. Stove/Oven</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenStoveOven"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenStoveOven === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenStoveOvenOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>13. Stove Vent</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenStoveVent"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenStoveVent === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenStoveVentOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>14. Microwave</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenMicrowave"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenMicrowave === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenMicrowaveOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>15. Dishwasher</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenDishwasher"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenDishwasher === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenDishwasherOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>16. Sink/Fixtures/Plumbing</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenSinkFixtures"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenSinkFixtures === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenSinkFixturesOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>17. Counter</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenCounter"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenCounter === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenCounterOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>18. Garbage Disposal</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenGarbageDisposal"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenGarbageDisposal === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenGarbageDisposalOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>19. Washer/Dryer</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenWasherDryer"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenWasherDryer === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenWasherDryerOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>20. Dryer Vent</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select</InputLabel>
                <Controller
                  name="kitchenDryerVent"
                  control={control}
                  render={(field) => (
                    <Select {...field} label="Select">
                      <MenuItem value="new">New</MenuItem>
                      <MenuItem value="normal">Normal</MenuItem>
                      <MenuItem value="damaged">Damaged</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
            </div>
            {kitchenValues?.kitchenDryerVent === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenDryerVentOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.FormList}`}>
          <p className={`${styles.Title}`}>21. Other</p>
          <div className={`${styles.FormListRow}`}>
            <div className={`${styles.FormFullSec} FormGroup`}>
              <FormControl fullWidth>
                <Controller
                  name="kitchenOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </FormControl>
            </div>
            {/* {kitchenValues?.kitchenOther === "other" && (
              <div className={`${styles.FormFullSec} FormGroup`}>
                <Controller
                  name="kitchenOtherOther"
                  control={control}
                  render={(field) => (
                    <TextField {...field} fullWidth label="Add Description" />
                  )}
                />
              </div>
            )} */}
          </div>
        </div>

        {/* <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Floor and Floor Covering
            </InputLabel>
            <Controller
              name="kitchenfloorCovering"
              control={control}
              render={(field) => (
                <Select {...field} label="Floor and Floor Covering">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenfloorCovering === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenfloorCoveringOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Walls and Ceiling/Caulking
            </InputLabel>
            <Controller
              name="kitchenWallsCeiling"
              control={control}
              render={(field) => (
                <Select {...field} label="Walls and Ceiling/Caulking">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenWallsCeiling === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenWallsCeilingOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Window(s)</InputLabel>
            <Controller
              name="kitchenWindow"
              control={control}
              render={(field) => (
                <Select {...field} label="Window(s)">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenWindow === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenWindowOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Window Covering(s)
            </InputLabel>
            <Controller
              name="kitchenWindowConvering"
              control={control}
              render={(field) => (
                <Select {...field} label="Window Covering(s)">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenWindowConvering === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenWindowConveringOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Lighting Fixture(s)/Fans
            </InputLabel>
            <Controller
              name="kitchenLightingFans"
              control={control}
              render={(field) => (
                <Select {...field} label="Lighting Fixture(s)/Fans">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenLightingFans === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenLightingFansOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Door(s)/Hardware
            </InputLabel>
            <Controller
              name="kitchenDoorHardware"
              control={control}
              render={(field) => (
                <Select {...field} label="Door(s)/Hardware">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenDoorHardware === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenDoorHardwareOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Heating</InputLabel>
            <Controller
              name="kitchenHeating"
              control={control}
              render={(field) => (
                <Select {...field} label="Heating">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenHeating === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenHeatingOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Outlets/Switches
            </InputLabel>
            <Controller
              name="kitchenOutletsSwitches"
              control={control}
              render={(field) => (
                <Select {...field} label="Outlets/Switches">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenOutletsSwitches === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenOutletsSwitchesOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Smoke Alarms/CO Alarms
            </InputLabel>
            <Controller
              name="kitchenSmokeAlarm"
              control={control}
              render={(field) => (
                <Select {...field} label="Smoke Alarms/CO Alarms">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenSmokeAlarm === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenSmokeAlarmOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Cabinets/Hardware
            </InputLabel>
            <Controller
              name="kitchenCabinetsHardware"
              control={control}
              render={(field) => (
                <Select {...field} label="Cabinets/Hardware">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenCabinetsHardware === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenCabinetsHardwareOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Refrigerator</InputLabel>
            <Controller
              name="kitchenRefrigerator"
              control={control}
              render={(field) => (
                <Select {...field} label="Refrigerator">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenRefrigerator === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenRefrigeratorOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Stove/Oven</InputLabel>
            <Controller
              name="kitchenStoveOven"
              control={control}
              render={(field) => (
                <Select {...field} label="Stove/Oven">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenStoveOven === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenStoveOvenOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Stove Vent</InputLabel>
            <Controller
              name="kitchenStoveVent"
              control={control}
              render={(field) => (
                <Select {...field} label="Stove Vent">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenStoveVent === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenStoveVentOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Microwave</InputLabel>
            <Controller
              name="kitchenMicrowave"
              control={control}
              render={(field) => (
                <Select {...field} label="Microwave">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenMicrowave === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenMicrowaveOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Dishwasher</InputLabel>
            <Controller
              name="kitchenDishwasher"
              control={control}
              render={(field) => (
                <Select {...field} label="Dishwasher">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenDishwasher === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenDishwasherOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Sink/Fixtures/Plumbing
            </InputLabel>
            <Controller
              name="kitchenSinkFixtures"
              control={control}
              render={(field) => (
                <Select {...field} label="Sink/Fixtures/Plumbing">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenSinkFixtures === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenSinkFixturesOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Counter</InputLabel>
            <Controller
              name="kitchenCounter"
              control={control}
              render={(field) => (
                <Select {...field} label="Counter">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenCounter === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenCounterOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Garbage Disposal
            </InputLabel>
            <Controller
              name="kitchenGarbageDisposal"
              control={control}
              render={(field) => (
                <Select {...field} label="Garbage Disposal">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenGarbageDisposal === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenGarbageDisposalOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Washer/Dryer</InputLabel>
            <Controller
              name="kitchenWasherDryer"
              control={control}
              render={(field) => (
                <Select {...field} label="Washer/Dryer">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenWasherDryer === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenWasherDryerOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Dryer Vent</InputLabel>
            <Controller
              name="kitchenDryerVent"
              control={control}
              render={(field) => (
                <Select {...field} label="Dryer Vent">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenDryerVent === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenDryerVentOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div>
        <div className={`${styles.FormHalfSec} FormGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Other</InputLabel>
            <Controller
              name="kitchenOther"
              control={control}
              render={(field) => (
                <Select {...field} label="Other">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                      <MenuItem value="N/A">N/A</MenuItem>
                </Select>
              )}
            />
          </FormControl>
          {kitchenValues?.kitchenOther === "other" && (
            <div className={`${styles.CheckListOtherField}`}>
              <Controller
                name="kitchenOtherOther"
                control={control}
                render={(field) => (
                  <TextField {...field} fullWidth label="Add Description" />
                )}
              />
            </div>
          )}
        </div> */}

        <div className={`${styles.HalfSecFull}`}>
          <div className={`${styles.FileUpDuBUDiv}`}>
            <label
              htmlFor="file-upload-kitchen"
              className={`${styles.UploadLabel}`}
            >
              <span>
                <div className={`${styles.UpIcon}`}>
                  <img src="/static/img/upload-floor.svg" alt="" />
                </div>
                <p>Upload Pictures</p>
                <p className={`${styles.UploadText}`}>File size upto 5 MB</p>
              </span>
            </label>
            <input
              id="file-upload-kitchen"
              type="file"
              accept="image/*"
              multiple
              onChange={handleImageChange}
              style={{ display: "none" }}
            />
          </div>

          <div className={`${styles.UpIMGSec}`}>
            {uploadedImages.map((img, index) => (
              <div key={index} className={`${styles.ImgFile}`}>
                <img src={img.file_url} alt={img.file_path} />
                <Button
                  type="button"
                  onClick={() => removeImage(img.file_path)}
                >
                  <X />
                </Button>
              </div>
            ))}
          </div>
        </div>

        <div className={`${styles.ButtonAction}`}>
          <Button
            className={`${styles.CancelPopupBU}`}
            onClick={handleChange4("panel2")}
          >
            Cancel
          </Button>
          <Button type="submit" className={`${styles.SubmitPopupBU}`}>
            Save & Continue
          </Button>
        </div>
      </form>
    </div>
  );
};

export default KitchenForm;
